/**
 * Shell-width wrapper. Forwards `id` so sections built from Container can
 * still be anchor targets — previously the attribute was dropped silently.
 */
export default function Container({ children, className = '', as: Tag = 'div', id }) {
  return (
    <Tag data-component-id="src/components/ui/Container.jsx:7:4" data-component-path="src/components/ui/Container.jsx" data-component-line="7" data-component-end-line="9" data-component-file="Container.jsx" data-component-name="Tag" data-component-content="%7B%22elementName%22%3A%22Tag%22%2C%22id%22%3A%22%5Bvar%3Aid%5D%22%7D" id={id} className={`mx-auto w-full max-w-shell px-6 sm:px-8 lg:px-10 ${className}`}>
      {children}
    </Tag>
  );
}
